/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetBaseTimeZonesResponse } from '../../models/get-base-time-zones-response';

export interface ListBaseTimeZones$Params {
}

export function listBaseTimeZones(http: HttpClient, rootUrl: string, params?: ListBaseTimeZones$Params, context?: HttpContext): Observable<StrictHttpResponse<GetBaseTimeZonesResponse>> {
  const rb = new RequestBuilder(rootUrl, listBaseTimeZones.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetBaseTimeZonesResponse>;
    })
  );
}

listBaseTimeZones.PATH = '/api/scheduler/bases/time-zones';
